const ImageDomains = [
  'storage.fnf.co.kr',
  'pds.fnf.co.kr',
  'file.fnf.co.kr',
  'null',
  'dev-file.fnf.co.kr',
  'ec-oms-ad.dev.fnf.co.kr',
  'ec-oms-ad.fnf.co.kr',
  'hris-storage-dev.fnf.co.kr',
  'hris-storage.fnf.co.kr',
];

module.exports = { ImageDomains };
